import { render, staticRenderFns } from "./Raport_grad_ocupare.vue?vue&type=template&id=f2fb3564&scoped=true"
import script from "./Raport_grad_ocupare.vue?vue&type=script&lang=js"
export * from "./Raport_grad_ocupare.vue?vue&type=script&lang=js"
import style0 from "./Raport_grad_ocupare.vue?vue&type=style&index=0&id=f2fb3564&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fb3564",
  null
  
)

export default component.exports